export default {
  semantic: {
    surface: {
      0: '#ffffff',
      50: '#f8fafc',
      100: '#f1f5f9',
      200: '#e2e8f0',
      300: '#cbd5e1', // light
      400: '#94a3b8',
      500: '#64748b', // base
      600: '#475569',
      700: '#334155', // dark
      800: '#1e293b',
      900: '#0f172a',
      950: '#020617',
    },
    primary: {
      50: '#a0d4cd',
      100: '#a0d4cd',
      200: '#a0d4cd',
      300: '#a0d4cd', // light
      400: '#334eb8',
      500: '#243782', // base
      600: '#1d2c68',
      700: '#16214e', // dark
      800: '#0e1634',
      900: '#070b1a',
      950: '#04050d',
    },
    tangerine: {
      50: '#ffe9e2',
      100: '#ffd3c6',
      200: '#ffa88e',
      250: '#F39671',
      300: '#F39671', // light
      400: '#f55f37',
      500: '#e94e24', // base
      600: '#e42313',
      700: '#e42313', // dark
      800: '#842510',
      900: '#6a1d0c',
      950: '#3e0f06',
    },
    mint: {
      50: '#e6f7f5',
      100: '#cdefea',
      200: '#9bdfd6',
      300: '#a0d4cd', // light
      400: '#47b9ab',
      500: '#43aaa0', // base
      600: '#35867e',
      700: '#006e6a', // dark
      800: '#1d4a46',
      900: '#13302d',
      950: '#0b1b1a',
    },

    sfsOrange: {
      50: '#fff6e5',
      100: '#ffebc2',
      200: '#ffd785',
      300: '#fecd50', // light
      400: '#f3b02d',
      500: '#eca935', // base
      600: '#c78d2b',
      700: '#ef7d00', // dark
      800: '#7a5919',
      900: '#5f4613',
      950: '#322508',
    },
    anthracite: {
      500: '#2b2b34',
    },
  },
}
